import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MapService } from '../../../services/map/map.service';
import { RoutePlanningService } from '../../../services/route-planning/route-planning.service';
import { CardDesignComponent } from 'src/app/@shared/components/design/slide-up-card/card-design.component';
import { Overlay } from '@angular/cdk/overlay';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { MapComponent } from './map.component';
import { BaseAutoCompleteComponent } from '../../route-planner-form/base-auto-complete.component';
import { FavoritesService } from '../../../services/favorites/favorites.service';

@Component({
    template: ``,
    standalone: false
})
export abstract class BaseMap<T>
  extends BaseAutoCompleteComponent<T>
  implements AfterViewInit
{
  @ViewChild(MapComponent) mapComponent?: MapComponent;
  protected _mapInitialized: boolean = false;
  protected _errLoadingMap: boolean = false;

  constructor(
    favoritesService: FavoritesService,
    resizeService: ResizeService,
    overlay: Overlay,

    protected readonly mapService: MapService,
    protected override readonly routePlanningService: RoutePlanningService
  ) {
    super(favoritesService, routePlanningService, resizeService, overlay);
  }

  abstract ngAfterViewInit();

  protected override insertChosenValueToStorage(value: T) {}
}
